import { render, staticRenderFns } from "./ObservationInfomation.vue?vue&type=template&id=6f4ba689&scoped=true"
import script from "./ObservationInfomation.vue?vue&type=script&lang=js"
export * from "./ObservationInfomation.vue?vue&type=script&lang=js"
import style0 from "./ObservationInfomation.vue?vue&type=style&index=0&id=6f4ba689&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4ba689",
  null
  
)

export default component.exports